import { styled, ResizeContainer } from "@sourceful/shared-components";
import { getSanityImgUrl } from "@lib/sanity";
import BannerContent from "./bannerContent";
import { getForegroundImageSrc, getImageGridColumn, getImageGridRow } from "./helpers";
import { BannerInstance } from "@sourceful/shared-types";
import toRem from "@styles/postprocess/conversion/to-rem";

const ImageWrapper = styled("div", {});

const BannerWrapper = styled("div", {
  background: "white",
  border: 0,
  display: "grid",
  overflow: "hidden",
  maxHeight: toRem(600),
  variants: {
    appearance: {
      card: {
        boxShadow: "none",
        borderRadius: "$medium",
      },
      default: {},
    },
  },
});

const PrimaryImage = styled("img", {
  maxWidth: "100%",
  width: "100%",
  height: "100%",
  maxHeight: "675px",
});

const CONTAINER_BREAKPOINT = 700;

export interface BannerNewProps {
  bannerInstance: BannerInstance;
  appearance?: "card" | "default";
}

export const BannerNew = ({ bannerInstance, appearance = "default" }: BannerNewProps) => {
  const { banner, bgImagePosition, bgImageSize, bgColor, fgImageSize, fgImagePosition, layout } =
    bannerInstance;

  const { fgImage, bgImage } = banner;
  const backgroundImage = `url("${
    bgImage ? getSanityImgUrl(bgImage?.asset._ref || "", base => base.width(1200)) : ""
  }")`;

  return (
    <ResizeContainer>
      {({ width }) => {
        if (width === undefined) {
          return null;
        }

        const hasAdequateSpace = width > CONTAINER_BREAKPOINT;

        return (
          <BannerWrapper
            appearance={appearance}
            css={{
              backgroundColor: bgColor?.value || "white",
              backgroundImage,
              backgroundSize: bgImageSize,
              backgroundRepeat: "no-repeat",
              backgroundPosition: bgImagePosition,
              height: "675px",
              gridTemplateColumns: "repeat(4, 1fr)",
              gridTemplateRows: "repeat(4, 1fr)",
            }}
          >
            {fgImage && (
              <ImageWrapper
                className="img-wrapper"
                css={{
                  gridColumn: getImageGridColumn(layout, hasAdequateSpace),
                  gridRow: getImageGridRow(layout, hasAdequateSpace),
                }}
              >
                <PrimaryImage
                  src={getForegroundImageSrc(fgImage.asset._ref, layout)}
                  loading="lazy"
                  css={{
                    // objectFit:
                    //   !hasAdequateSpace && fgImageSize === SanityImageSize.CONTAIN
                    //     ? "cover" // override image size value when space is restriced and fg image is contained in order to avoid empty space at the bottom
                    //     : fgImageSize,
                    objectFit: fgImageSize,
                    objectPosition: fgImagePosition,
                    // gridColumn: getImageGridColumn(layout, hasAdequateSpace),
                    // gridRow: getImageGridRow(layout, hasAdequateSpace),
                  }}
                  alt={fgImage.asset.altText ?? ""}
                />
              </ImageWrapper>
            )}
            <BannerContent bannerInstance={bannerInstance} hasAdequateSpace={hasAdequateSpace} />
          </BannerWrapper>
        );
      }}
    </ResizeContainer>
  );
};

export default BannerNew;
